import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { JuridicoHeader } from '../../../juridico/includes/header.component';
import { JuridicoFooter } from '../../../juridico/includes/footer.component';

@Component({
    selector: 'recuperar-senha-profile',
    templateUrl: './recuperar-senha.component.html',
    styleUrls: ['./recuperar-senha.component.css']
})

export class RecuperarSenhaComponent implements OnInit {
    email: string = "";
    codigo: string = "";
    sucesso: boolean = false;
    error: boolean = false;
    isNotEquals:boolean = false;

    constructor(private router: ActivatedRoute, private http: HttpClient) {
        this.router.params.subscribe(params => {
            this.email = params.email;
            this.codigo = params.codigo;
        });
        console.log(this.email, this.codigo);
    }

    alterarSenha(dados) {
        this.sucesso = false;
        this.error = false;

        this.isNotEquals = (dados.value.senha !== dados.value.confirmacaoSenha);

        if (dados.valid) {
            var data = {
                Token: this.codigo,
                Email: this.email,
                NewPassword: dados.value.senha,
                ConfirmPassword: dados.value.confirmacaoSenha
            };
            this.http.post(environment.serverApi + '/account/ChangePasswordForgot', data, {})
                .subscribe((response) => {
                    this.sucesso = true;
                }, error => {
                    this.sucesso = false;
                    this.error = true;
                })
        }
    }

    ngOnInit() {}

}
